import AXIOS from '@/axios-instance';

function createUtf8Blob(data) {
  return new Blob([data], { type: 'text/plain; charset=UTF-8' });
}

export default {
  authenticateUser(userName, password){
    let formDataForLogin = new FormData();
    formDataForLogin.append('userName', userName);
    formDataForLogin.append('password', createUtf8Blob(password));
      return AXIOS.post("/authenticate", formDataForLogin, {
        headers: { "Content-Type": "multipart/form-data" }
      });
  },
  setPasswordForAuthToken(password, authToken){
    let formDataForLogin = new FormData();
    formDataForLogin.append('authToken', authToken);
    formDataForLogin.append('password', createUtf8Blob(password));
      return AXIOS.post("/authenticate/authToken", formDataForLogin, {
        headers: { "Content-Type": "multipart/form-data" }
      });
  },
  resetPassword(email){
    return AXIOS.post("authenticate/resetPassword", email, {
      headers: { "Content-Type": "application/json" }
    });
  }
}